import { Button, ButtonProps } from '@mui/material'
import React from 'react'

import Span from '@/app/component/atom/span'
import CustomTooltip from '@/app/component/atom/tooltip'

type Props = ButtonProps & {
  isDirty: boolean
  isSubmitting: boolean
  tooltipDirty?: React.ReactNode
  tooltipSubmitting?: React.ReactNode
  tooltipInvalid?: React.ReactNode
}

const SubmitButton: React.FC<Props> = ({
  disabled: buttonDisabled,
  isDirty,
  isSubmitting,
  tooltipDirty = 'No changes have been made',
  tooltipSubmitting = 'Saving changes',
  ...props
}) => {
  const disabled = buttonDisabled || !isDirty
  const tooltip = React.useMemo(() => {
    if (isSubmitting) {
      return tooltipSubmitting
    }
    if (!isDirty) {
      return tooltipDirty
    }
    return ''
  }, [isDirty, isSubmitting, tooltipDirty, tooltipSubmitting])

  return (
    <CustomTooltip title={tooltip}>
      <Span data-testid="submit-button">
        <Button
          color="primary"
          disabled={disabled}
          loading={isSubmitting}
          type="submit"
          variant="contained"
          {...props}
        />
      </Span>
    </CustomTooltip>
  )
}

export default SubmitButton

export type { Props as SubmitButtonProps }
